import { h, Fragment, Component } from "preact";
import { useMemo, useEffect } from 'preact/hooks'
import { observer } from "mobx-react";
import { withStore } from "@searchspring/snap-preact-components";
import "./Header.css";
import { Tabs } from "../Tabs/Tabs";


@withStore
@observer
export class Header extends Component {
  render() {
    console.log("this.props ", this.props);
    const { pagination, search, custom } = this.props.store;

    useMemo(() => {
      if (search && search.query) {
        /* Updating the original page title because the original result count is mismatching with searchspring */
        const title = document.querySelector('title.page-title');
        //title.textContent = `Search: ${pagination.totalResults} results found for "${search.query.string}"`;  
      }
    }, [pagination.totalResults])

    return (
      <header class={`ss-header-container ${pagination.totalResults > 0 ? 'ss-header-results-found' : 'ss-header-results-not-found'}`}>
          {pagination.totalResults ? (
            <>
              <h2 class="ss-title ss-results-title headline headline-medium">
                {window.Resources.searchspring.results.resultsHeading}
                {search?.query && (
                  <span class="ss-results-query">
                    <br/>{search.query.string}
                  </span>
                )}
              </h2>
            </>
          ) : (
            pagination.totalResults === 0 && (
              <h2 class="ss-title ss-results-title ss-no-results-title headline headline-medium">
                {search?.query &&
                  <>
                    {window.Resources.searchspring.results.noResultsHeading}
                    <span class="ss-results-query">
                      <br/>{search.query.string}
                    </span>
                    <span class="ss-results-header-body body-medium">
                      {window.Resources.searchspring.results.noResultsCallToAction}
                    </span>
                  </>
                }
              </h2>
            )
          )}
          <Tabs tabs={this.props.tabs}/>
      </header>
    );
  }
}
